import { Archive, Headphones, Search } from 'lucide-react';
import type { ContactConversation } from '../../app/legacy-types';
import { ChannelFilters, ConversationAvatar, type ContactChannelFilter } from './ChannelIdentity';
import { formatContactShort } from './contactCenterModel';

export type ConversationListProps = {
  rows: ContactConversation[];
  selectedId?: string | null;
  status: 'ACTIVE' | 'CLOSED';
  channel: ContactChannelFilter;
  search: string;
  mineOnly: boolean;
  unreadOnly: boolean;
  unansweredOnly: boolean;
  loading: boolean;
  error: boolean;
  onSelect: (conversation: ContactConversation) => void;
  onStatusChange: (status: 'ACTIVE' | 'CLOSED') => void;
  onChannelChange: (channel: ContactChannelFilter) => void;
  onSearchChange: (search: string) => void;
  onMineChange: (value: boolean) => void;
  onUnreadChange: (value: boolean) => void;
  onUnansweredChange: (value: boolean) => void;
  onRetry: () => void;
};

function Skeleton() {
  return <div className="page-skeleton" aria-label="Загрузка обращений"><span /><span /><span /><span /></div>;
}

export function ConversationList(props: ConversationListProps) {
  return <aside className="surface contact-list-panel v2" aria-label="Список обращений">
    <div className="contact-list-toolbar">
      <div className="contact-filter-row">
        <button type="button" className={props.status === 'ACTIVE' ? 'active' : ''} aria-pressed={props.status === 'ACTIVE'} onClick={() => props.onStatusChange('ACTIVE')}>Открытые</button>
        <button type="button" className={props.status === 'CLOSED' ? 'active' : ''} aria-pressed={props.status === 'CLOSED'} onClick={() => props.onStatusChange('CLOSED')}><Archive /> Архив</button>
      </div>
      <ChannelFilters value={props.channel} onChange={props.onChannelChange} />
      <div className="contact-filter-row contact-workspace-filters" aria-label="Фильтры обращений">
        <button type="button" className={props.mineOnly ? 'active' : ''} aria-pressed={props.mineOnly} onClick={() => props.onMineChange(!props.mineOnly)}>Мои</button>
        <button type="button" className={props.unreadOnly ? 'active' : ''} aria-pressed={props.unreadOnly} onClick={() => props.onUnreadChange(!props.unreadOnly)}>Непрочитанные</button>
        <button type="button" className={props.unansweredOnly ? 'active' : ''} aria-pressed={props.unansweredOnly} onClick={() => props.onUnansweredChange(!props.unansweredOnly)}>Без ответа</button>
      </div>
      <label className="contact-search"><Search /><input value={props.search} onChange={event => props.onSearchChange(event.target.value)} placeholder="Поиск по чатам, письмам и файлам" aria-label="Поиск обращений" /></label>
    </div>
    <div className="contact-conversations v2" role="listbox" aria-label="Обращения">
      {props.loading && <Skeleton />}
      {props.error && <div className="form-error">Не удалось загрузить обращения. <button type="button" onClick={props.onRetry}>Повторить</button></div>}
      {!props.loading && !props.error && !props.rows.length && <div className="empty-state compact"><span><Headphones /></span><b>Диалогов пока нет</b><p>Новые обращения появятся здесь автоматически.</p></div>}
      {props.rows.map(item => <button type="button" role="option" aria-selected={props.selectedId === item.id} key={item.id} className={props.selectedId === item.id ? 'active' : ''} onClick={() => props.onSelect(item)}>
        <ConversationAvatar provider={item.provider} name={item.customer_name || item.title || item.customer_external_id || 'Собеседник'} />
        <span><b>{item.title}</b><small>{item.customer_phone || item.customer_name || item.customer_external_id || item.channel_name}</small><em>{item.last_message_text || 'Без сообщений'}</em></span>
        <time>{item.last_message_at ? formatContactShort(item.last_message_at) : ''}</time>{item.unread_count > 0 && <strong>{item.unread_count}</strong>}
      </button>)}
    </div>
  </aside>;
}
